import { AbstractCommand } from 'src/models/command';

class SetTheContactPictureForTheMailAddressCommand extends AbstractCommand {
	readonly name = 'IFS_Desktop_Command_Command_Legacy_Modules_Mail_SetTheContactPictureForTheMailAddress';

	public constructor(contactMailAddress: string, contactPictureVersion: number, payload: string) {
		super();
		this.parameters = {
			contactMailAddress,
			contactPictureVersion,
			payload,
		};
	}
}

export { SetTheContactPictureForTheMailAddressCommand };
